import { createContext } from 'react';

const CurrentUser = createContext({
  id: null,
  first_name: null,
  last_name: null,
  email: null,
});

export default CurrentUser;
